import { axiosBase, errorHandler } from './axios';
const inviteUser = (payload: any) => {

  return axiosBase
    .post('/api/v1/users/invite', payload)
    .then((res) => res.data)
    .catch((err) => errorHandler(err));
};

const viewInvitation = (token: string) => {
  return axiosBase
    .get(`/api/v1/viewInvitation?token=${encodeURIComponent(token)}`)
    .then((res) => res.data)
    .catch((err) => errorHandler(err));
};

const lookupReferrer = (email: string) => {
  return axiosBase
    .get(`/public/referrers/lookup?email=${encodeURIComponent(email)}`)
    .then((res) => res.data)
    .catch((err) => errorHandler(err));
};

const sendOTP = (payload: any) => {
  return axiosBase
    .post('/api/v1/sendOTP', payload)
    .then((res) => res.data)
    .catch((err) => errorHandler(err));
};

const verifyOTP = (payload: any) => {
  return axiosBase
    .post('/api/v1/verifyOTP', payload)
    .then((res) => res.data)
    .catch((err) => errorHandler(err));
};

const signup = (payload: any) => {
  return axiosBase
    .post('/api/v1/account/register', payload)
    .then((res) => res.data)
    .catch((err) => errorHandler(err));
};

const referralDecision = (payload: any) => {
  return axiosBase
    .post('/api/v1/referralDecision', payload)
    .then((res) => res.data)
    .catch((err) => errorHandler(err));
};

const fetchDraft = (tempId: string, role: string, type?: string, isInvite?: boolean) => {
  return axiosBase
    .post('/api/v1/account/register', { tempId, role, type, isInvite })
    .then((res) => res.data)
    .catch((err) => errorHandler(err));
};

const adminList = (status?: string) => {
  const q = status ? `?status=${encodeURIComponent(status)}` : '';
  return axiosBase
    .get(`/api/v1/admin/applications${q}`)
    .then((res) => res.data)
    .catch((err) => errorHandler(err));
};

const fetchReferrals = (params: any) => {
  return axiosBase
    .post('/api/v1/account/referrals', params)
    .then((res) => res.data)
    .catch((err) => errorHandler(err));
};

const fetchUserDetails = (portfolioId: string) => {
  return axiosBase
    .get(`/api/v1/account/application/${portfolioId}`)
    .then((res) => res.data)
    .catch((err) => errorHandler(err));
};

const processDecision = (payload: any) => {
  const { portfolioId, ...body } = payload;
  return axiosBase
    .post(`/api/v1/account/decision/${portfolioId}`, body)
    .then((res) => res.data)
    .catch((err) => errorHandler(err));
};

export const onboardingService = {
  inviteUser,
  viewInvitation,
  lookupReferrer,
  sendOTP,
  verifyOTP,
  signup,
  referralDecision,
  fetchDraft,
  adminList,
  fetchReferrals,
  fetchUserDetails,
  processDecision,

};
